import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Stack,
  IconButton,
  Button,
  Typography,
} from "@mui/material";

import { colors } from "../../global/globalStyle";

export interface ModalDefaultProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  bodyMessageTitle: React.ReactNode;
  bodyMessageSubTitle: React.ReactNode;
  textConfirm: string;
  onClickConfirm: () => void;
  textCancel: string;
  onClickCancel: () => void;
  bodyMessageMarginTop?: string;
  bodyMessageMarginBetweenTitleAndSubTitle?: string;
  destructive?: boolean;
  cancelFirst?: boolean;
}

export const ModalDefault: React.FC<ModalDefaultProps> = ({
  openModal,
  setOpenModal,
  title,
  bodyMessageTitle,
  bodyMessageSubTitle,
  textConfirm,
  onClickConfirm,
  textCancel,
  onClickCancel,
  bodyMessageMarginTop = "35px",
  bodyMessageMarginBetweenTitleAndSubTitle = "32px",
  destructive = false,
  cancelFirst = false,
}) => {
  const handleClose = () => setOpenModal(false);

  return (
    <Dialog open={openModal} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: colors.background_primary,
          color: colors.default_base_white,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography fontSize={20} fontWeight={700} component="span">
          {title}
        </Typography>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon sx={{ color: colors.general_icons }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <Stack
          mt={bodyMessageMarginTop}
          spacing={bodyMessageMarginBetweenTitleAndSubTitle}
        >
          <Typography
            fontSize={18}
            fontWeight={400}
            color={colors.neutral_black}
          >
            {bodyMessageTitle}
          </Typography>
          {bodyMessageSubTitle && (
            <Typography fontSize={14} fontWeight={300}>
              {bodyMessageSubTitle}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Stack direction="row" spacing={2} width="100%" maxWidth={300}>
          {cancelFirst && (
            <Button
              fullWidth
              variant="outlined"
              color="inherit"
              sx={{ borderColor: colors.default_base_grey }}
              onClick={onClickCancel}
            >
              {textCancel}
            </Button>
          )}
          <Button
            fullWidth
            variant="contained"
            color={destructive ? "error" : "primary"}
            sx={
              !destructive
                ? { backgroundColor: colors.primary_default }
                : undefined
            }
            onClick={onClickConfirm}
          >
            {textConfirm}
          </Button>
          {!cancelFirst && (
            <Button
              fullWidth
              variant="contained"
              sx={{
                backgroundColor: colors.background_primary,
                border: `1px solid ${colors.primary_default}`,
              }}
              onClick={onClickCancel}
            >
              {textCancel}
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDefault;
